import {InjectionToken} from '@angular/core';
import {MapService} from './map.service';

/**
 * The map service is injected at boot time, see main.ts
 * We rely on device info which requires an async operation
 */
export const MAP_SERVICE: InjectionToken<MapService> = new InjectionToken<MapService>('map:service');
